// extracted by mini-css-extract-plugin
export default {"blockText":"blockText_blockText__P9hNe"};